import React from 'react'
import PropTypes from 'prop-types'
import Collapsible from 'react-collapsible'
import GlobeMenuItem from './globeMenuItem'
import GlobeMenuItemFull from './globeMenuItemFull'
import * as style from './globe.module.scss'

const GlobeMenu = ({ markets, fullDisplay }) => {
  return (
    <div className={style.globeMenu}>
      {Object.keys(markets).map(((market, i) => {
        return (
          <Collapsible open={i === 0 ? true : false} trigger={market} easing="ease" key={i}>
            <ul>
              {markets[market].map(office => {
                return fullDisplay ?
                  <GlobeMenuItemFull key={office.title} office={office} /> :
                  <GlobeMenuItem key={office.title} office={office} />
              })}
            </ul>
          </Collapsible>
        )
      }))}
    </div>
  )
}

GlobeMenu.propTypes = {
  markets: PropTypes.object.isRequired,
}

export default GlobeMenu
